import { EmailRounded } from "@mui/icons-material";
import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";

export default function EmailReminder({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record, reminderEvent, action } = props;
  const [open, setOpen] = React.useState(false);
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    refresh();
    setOpen(false);
    // refresh();
  };

  return (
    <React.Fragment>
      <EmailRounded
        id="btn-application-email-reminder"
        color="primary"
        fontSize="small"
        sx={{
          ...props?.sx,
          cursor: "pointer",
          "&:hover": { color: "gray" },
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-email-reminder"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="xs"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            let reqUrl = ``;
            if (
              record?.sStatus == "Pre-Approved" ||
              record?.sStatus == "pre-approve"
            ) {
              reqUrl = `email/reminder/preapprove`;
            } else if (
              record?.sStatus == "Counter" ||
              record?.sStatus == "Countered"
            ) {
              reqUrl = `email/reminder/counter`;
            }

            if (reminderEvent == "counselor") {
              reqUrl = `email/reminder/counselor`;
            } else if (reminderEvent == "employer") {
              reqUrl = `email/reminder/employer`;
            }
            if (reqUrl == "") {
              errorNotify("Invalid status for reminder");
              return;
            }
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: {},
            });
            if (
              response &&
              (response.status == "200" || response.code == "200")
            ) {
              if (typeof props?.handleCallBackRefreshMenu === "function") {
                props.handleCallBackRefreshMenu();
              }
              console.log("Email reminder sent successfully for appId:", appId);
              refresh();
              successNotify("Message sent successfully.");
              handleClose();
            } else {
              errorNotify("Data not saved");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            mb: 2,
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          {action == "resend" ? "REVERIFY" : "Reminder"}
        </DialogTitle>
        <DialogContent>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <DialogContentText>
            {record?.sStatus == "Countered" && (
              <Typography variant="body2">
                {/* Send a message to remind the applicant {appId} to respond to the
                counter offer.  */}
                Resend the email and message to applicant to remind them to
                review the offer.
              </Typography>
            )}
            {record?.sStatus == "Pre-Approved" ||
              (record?.sStatus == "pre-approve" && (
                <Typography variant="body2">
                  {action == "resend" ? (
                    <>
                      Resending the form will erase existing verification data.
                      Click “Submit” to proceed.
                    </>
                  ) : (
                    <>
                      Resend the email and message to applicant to remind them
                      to review the offer.
                    </>
                  )}
                </Typography>
              ))}
            {(reminderEvent == "counselor" || reminderEvent == "employer") && (
              <Typography variant="body2">
                {action == "resend" ? (
                  <>
                    Resending the form will erase existing verification data.
                    Click “Submit” to proceed.
                  </>
                ) : (
                  <>
                    Send a reminder to the party responsible for completing the
                    verification.
                  </>
                )}
              </Typography>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
